import { GetColumnInput, IColumn } from '../types';
import { UniColumn } from './uni';
import { OfferColumn } from './offer';
import { CourseColumn } from './course';
import { NationalityColumn } from './nationality';
import { AgentColumn } from './masterAgents';
import { QSColumn } from './questionComplete';
import { DOCSColumn } from './documentComplete';
import { VisaStatusColumn } from './visaStatus';
import { ArrStatusColumn } from './travelStatus';
import { CONFColumn } from './successPrediction';
import { FundsMaturedColumn } from './fundsMatured';
import { TOUCHColumn } from './lastTouch';

import { ServicesColumn } from './partners';
import { SelectColumn } from './select';
import { ConditionalStatusColumn } from './conditionalStatus';
import { ImmigrationProvidersColumn } from './immigrationProviders';
import { ExpectedDepositDateColumn } from './expectedDepositDate';
import { FollowUpDocsColumn } from './followUpDocumentComplete';
import { AgentDocsColumn } from './agentDocumentComplete';
import { AgentDetailsStatusColumn } from './agentDetailsStatus';
import { InterviewColumn } from './interview';
import { AccommodationColumn } from './accommodationStatus';

import { StudentColumn } from './student';
import { RecordedInterviewColumn } from './recordedInterview';
import { DaysInStageColumn } from './daysInStage';
import { ShareCodeColumn } from './shareCode';

export const getColumns = (input: GetColumnInput): IColumn[] => [
  SelectColumn(input),
  StudentColumn(input),
  UniColumn(),
  OfferColumn(),
  CourseColumn(),
  NationalityColumn(),
  AgentColumn(input),
  ConditionalStatusColumn(),
  ServicesColumn(),
  ImmigrationProvidersColumn(),
  QSColumn(),
  DOCSColumn(),
  AgentDocsColumn(),
  AgentDetailsStatusColumn(),
  VisaStatusColumn(),
  ArrStatusColumn(),
  AccommodationColumn(),
  ShareCodeColumn(),
  FollowUpDocsColumn(),
  InterviewColumn(),
  RecordedInterviewColumn(),
  CONFColumn(),
  FundsMaturedColumn(),
  ExpectedDepositDateColumn(),
  DaysInStageColumn(),
  TOUCHColumn(),
];
